import axiosInstance from "../../api/axiosInstance";

export const fetchSocialMediaAPI = async () => {
  const res = await axiosInstance.get("socialMedia/get-all-social-media");
  return res.data;
};

export const updateSocialMediaAPI = async ({ name, ...data }) => {
  const res = await axiosInstance.put("socialMedia/update-social-media", {
    name,
    ...data,
  });
  return res.data;
};
